// TabPanelComponent.jsx (or .tsx)
import * as React from "react";
import Box from "@mui/material/Box";

export function TabPanelProduct(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            // ensure no default spacing on the outer node
            style={{ margin: 0, padding: 0, ...(other.style || {}) }}
            {...other}
        >
            {value === index && (
                <Box
                    // ZERO spacing inside too
                    sx={{ p: 0, m: 0 }}
                    className="tabpanel-content"
                >
                    {children}
                </Box>
            )}
        </div>
    );
}
